import React from 'react'
import { connect } from 'react-redux'

import FilterReasons from 'syft-acp-util/components/FilterForm/FilterReasons'
import { AppealEntity, Assignee } from 'syft-acp-core/store/types'

import { DataAppealAssigneeDropdownProps as Props } from './DataAppealAssigneeDropdown.types'

export const storeConnector = connect(state => ({
  assignees: state?.appeals?.assignees,
  me: state?.auth?.userData,
}))

const getCurrentAssigneeOption = (data: AppealEntity, assignees: Assignee[], currentUserId?: number) => {
  const currentAssignee = data.assignee
  if (!currentAssignee?.id) return []

  const currentAssigneeId = Number(currentAssignee.id)
  const isCurrentUser = currentAssigneeId === Number(currentUserId)
  const isKnownAssignee = assignees.some(assignee => assignee.id === currentAssigneeId)
  if (isCurrentUser || isKnownAssignee) return []

  return [{ id: String(currentAssigneeId), label: currentAssignee.full_name }]
}

const getExtraOptions = (data: AppealEntity, assignees: Assignee[], currentUserId?: number) => [
  ...(currentUserId ? [{ id: String(currentUserId), label: 'Me' }] : []),
  ...getCurrentAssigneeOption(data, assignees, currentUserId),
]

const getCurrentAssigneeId = (data: AppealEntity) => (data.assignee?.id ? Number(data.assignee.id) : null)

const getCurrentAssigneeName = (data: AppealEntity) => data.assignee?.full_name || 'No Assignee'

const DataAppealAssigneeDropdown = ({
  disabled = false,
  editable = false,
  data,
  onChange,
  assignees = [],
  me,
}: Props) => {
  const currentAssigneeId = getCurrentAssigneeId(data)
  const value = currentAssigneeId ? String(currentAssigneeId) : undefined
  const extraOptions = getExtraOptions(data, assignees, me?.id)

  if (editable) {
    return (
      <FilterReasons
        type="assignees"
        headerLabel="No Assignee"
        onChange={onChange}
        value={value}
        extraOptions={extraOptions}
        disabled={disabled}
      />
    )
  }

  return <div className="plain-text">{getCurrentAssigneeName(data)}</div>
}

export default storeConnector(DataAppealAssigneeDropdown)
